import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

function SelectedPatient({ patient, onClear }) {
  if (!patient) return null;

  return (
    <div className="flex items-center space-x-2 bg-primary-50 px-3 py-2 rounded-md">
      <span className="text-sm text-primary-700">
        Selected Patient: {patient.name} ({patient.id})
      </span>
      <button
        onClick={onClear}
        className="text-primary-500 hover:text-primary-700"
      >
        <XMarkIcon className="h-5 w-5" />
      </button>
    </div>
  );
}

export default SelectedPatient; 